/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LivekitEgressTemplateRouteImport } from './routes/livekit-egress-template'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as STokenRouteImport } from './routes/s/$token'
import { Route as ITokenRouteImport } from './routes/i/$token'
import { Route as DevHeyreachRouteImport } from './routes/dev/heyreach'
import { Route as AppConnectAiRouteImport } from './routes/app/connect-ai'
import { Route as AdminMatcherJobsRouteImport } from './routes/admin/matcher-jobs'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminStartupsIndexRouteImport } from './routes/admin/startups/index'
import { Route as AdminSignupQuestionIndexRouteImport } from './routes/admin/signup-question/index'
import { Route as AdminProfileChatsIndexRouteImport } from './routes/admin/profile-chats/index'
import { Route as AdminOutreachIndexRouteImport } from './routes/admin/outreach/index'
import { Route as AdminInvestorsIndexRouteImport } from './routes/admin/investors/index'
import { Route as AdminInvestorIndexIndexRouteImport } from './routes/admin/investor-index/index'
import { Route as AdminInvestorChecksIndexRouteImport } from './routes/admin/investor-checks/index'
import { Route as AdminHelpCenterIndexRouteImport } from './routes/admin/help-center/index'
import { Route as AdminFeedbackIndexRouteImport } from './routes/admin/feedback/index'
import { Route as AdminFeatureFlagsIndexRouteImport } from './routes/admin/feature-flags/index'
import { Route as AdminEvaluationsIndexRouteImport } from './routes/admin/evaluations/index'
import { Route as AdminEmailsIndexRouteImport } from './routes/admin/emails/index'
import { Route as AdminEmailTemplatesIndexRouteImport } from './routes/admin/email-templates/index'
import { Route as AdminDataRoomsIndexRouteImport } from './routes/admin/data-rooms/index'
import { Route as AdminBlogIndexRouteImport } from './routes/admin/blog/index'
import { Route as AdminAgentIndexRouteImport } from './routes/admin/agent/index'
import { Route as AppStartupIdRouteImport } from './routes/app/startup/$id'
import { Route as AppOauthLoginRouteImport } from './routes/app/oauth/login'
import { Route as AppOauthConsentRouteImport } from './routes/app/oauth/consent'
import { Route as AppInvestorIdRouteImport } from './routes/app/investor/$id'
import { Route as AppEvaluateStartupIdRouteImport } from './routes/app/evaluate.$startupId'
import { Route as AdminUsersIdRouteImport } from './routes/admin/users/$id'
import { Route as AdminStartupsIdRouteImport } from './routes/admin/startups/$id'
import { Route as AdminProfileChatsConversationIdRouteImport } from './routes/admin/profile-chats/$conversationId'
import { Route as AdminOutreachReplyClassificationRouteImport } from './routes/admin/outreach/reply-classification'
import { Route as AdminInvestorsUpdateProposalsRouteImport } from './routes/admin/investors/update-proposals'
import { Route as AdminInvestorsPortfolioResearchRouteImport } from './routes/admin/investors/portfolio-research'
import { Route as AdminInvestorsPersonaResearchRouteImport } from './routes/admin/investors/persona-research'
import { Route as AdminInvestorsNormalizePreferencesRouteImport } from './routes/admin/investors/normalize-preferences'
import { Route as AdminInvestorsActivityResearchRouteImport } from './routes/admin/investors/activity-research'
import { Route as AdminInvestorsIdRouteImport } from './routes/admin/investors/$id'
import { Route as AdminHelpCenterNewRouteImport } from './routes/admin/help-center/new'
import { Route as AdminHelpCenterIdRouteImport } from './routes/admin/help-center/$id'
import { Route as AdminEvaluationsIdRouteImport } from './routes/admin/evaluations/$id'
import { Route as AdminEmailsIdRouteImport } from './routes/admin/emails/$id'
import { Route as AdminEmailTemplatesTypeRouteImport } from './routes/admin/email-templates/$type'
import { Route as AdminDataRoomsIdRouteImport } from './routes/admin/data-rooms/$id'
import { Route as AdminBlogNewRouteImport } from './routes/admin/blog/new'
import { Route as AdminBlogIdRouteImport } from './routes/admin/blog/$id'
import { Route as AppStartupIdIndexRouteImport } from './routes/app/startup/$id/index'
import { Route as AppInvestorIdIndexRouteImport } from './routes/app/investor/$id/index'
import { Route as AdminAgentObserversIndexRouteImport } from './routes/admin/agent/observers/index'
import { Route as AppStartupIdUpdatesRouteImport } from './routes/app/startup/$id/updates'
import { Route as AppStartupIdSettingsRouteImport } from './routes/app/startup/$id/settings'
import { Route as AppStartupIdProfileRouteImport } from './routes/app/startup/$id/profile'
import { Route as AppStartupIdPreferencesRouteImport } from './routes/app/startup/$id/preferences'
import { Route as AppStartupIdPitchRouteImport } from './routes/app/startup/$id/pitch'
import { Route as AppStartupIdOutreachRouteImport } from './routes/app/startup/$id/outreach'
import { Route as AppStartupIdMeRouteImport } from './routes/app/startup/$id/me'
import { Route as AppStartupIdInvestorsRouteImport } from './routes/app/startup/$id/investors'
import { Route as AppStartupIdFeedRouteImport } from './routes/app/startup/$id/feed'
import { Route as AppStartupIdBillingRouteImport } from './routes/app/startup/$id/billing'
import { Route as AppStartupIdActivityRouteImport } from './routes/app/startup/$id/activity'
import { Route as AppInvestorIdWalletRouteImport } from './routes/app/investor/$id/wallet'
import { Route as AppInvestorIdSettingsRouteImport } from './routes/app/investor/$id/settings'
import { Route as AppInvestorIdSearchRouteImport } from './routes/app/investor/$id/search'
import { Route as AppInvestorIdPrivacyRouteImport } from './routes/app/investor/$id/privacy'
import { Route as AppInvestorIdPreferencesRouteImport } from './routes/app/investor/$id/preferences'
import { Route as AppInvestorIdNotificationsRouteImport } from './routes/app/investor/$id/notifications'
import { Route as AppInvestorIdMeRouteImport } from './routes/app/investor/$id/me'
import { Route as AppInvestorIdFollowsRouteImport } from './routes/app/investor/$id/follows'
import { Route as AppInvestorIdFeedRouteImport } from './routes/app/investor/$id/feed'
import { Route as AppInvestorIdDealFlowRouteImport } from './routes/app/investor/$id/deal-flow'
import { Route as AppInvestorIdCreditsRouteImport } from './routes/app/investor/$id/credits'
import { Route as AppInvestorIdConnectAiRouteImport } from './routes/app/investor/$id/connect-ai'
import { Route as AppStartupIdProfileIndexRouteImport } from './routes/app/startup/$id/profile/index'
import { Route as AppStartupIdOutreachIndexRouteImport } from './routes/app/startup/$id/outreach.index'
import { Route as AppStartupIdSettingsBillingRouteImport } from './routes/app/startup/$id/settings.billing'
import { Route as AppStartupIdSettingsAnalyticsRouteImport } from './routes/app/startup/$id/settings.analytics'
import { Route as AppStartupIdProfileLinksRouteImport } from './routes/app/startup/$id/profile/links'
import { Route as AppStartupIdProfileDeepInsightsRouteImport } from './routes/app/startup/$id/profile/deep-insights'
import { Route as AppStartupIdProfileAnalyticsRouteImport } from './routes/app/startup/$id/profile/analytics'
import { Route as AppStartupIdPitchStartRouteImport } from './routes/app/startup/$id/pitch_.start'
import { Route as AppStartupIdOutreachRepliesRouteImport } from './routes/app/startup/$id/outreach.replies'
import { Route as AppStartupIdOutreachArchiveRouteImport } from './routes/app/startup/$id/outreach.archive'
import { Route as AppStartupIdEvaluationEvaluationIdRouteImport } from './routes/app/startup/$id/evaluation.$evaluationId'
import { Route as AppInvestorIdStartupTokenRouteImport } from './routes/app/investor/$id/startup.$token'
import { Route as AppInvestorIdEvaluationEvaluationIdRouteImport } from './routes/app/investor/$id/evaluation.$evaluationId'
import { Route as AppInvestorIdEvaluateStartupIdRouteImport } from './routes/app/investor/$id/evaluate.$startupId'
import { Route as AppInvestorIdDealFlowArchiveRouteImport } from './routes/app/investor/$id/deal-flow_.archive'
import { Route as AppInvestorIdDealFlowStartupIdRouteImport } from './routes/app/investor/$id/deal-flow_.$startupId'
import { Route as AdminEvaluationsIdJudgeJudgeKeyRouteImport } from './routes/admin/evaluations/$id.judge.$judgeKey'
import { Route as AppStartupIdJudgeJudgeKeyEvaluationIdRouteImport } from './routes/app/startup/$id/judge.$judgeKey.$evaluationId'
import { Route as AppInvestorIdJudgeJudgeKeyEvaluationIdRouteImport } from './routes/app/investor/$id/judge.$judgeKey.$evaluationId'

const LivekitEgressTemplateRoute = LivekitEgressTemplateRouteImport.update({
  id: '/livekit-egress-template',
  path: '/livekit-egress-template',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DevHeyreachRoute = DevHeyreachRouteImport.update({
  id: '/dev/heyreach',
  path: '/dev/heyreach',
  getParentRoute: () => rootRouteImport,
} as any)
const AppConnectAiRoute = AppConnectAiRouteImport.update({
  id: '/connect-ai',
  path: '/connect-ai',
  getParentRoute: () => AppRoute,
} as any)
const AdminMatcherJobsRoute = AdminMatcherJobsRouteImport.update({
  id: '/matcher-jobs',
  path: '/matcher-jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStartupsIndexRoute = AdminStartupsIndexRouteImport.update({
  id: '/startups/',
  path: '/startups/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSignupQuestionIndexRoute =
  AdminSignupQuestionIndexRouteImport.update({
    id: '/signup-question/',
    path: '/signup-question/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminProfileChatsIndexRoute = AdminProfileChatsIndexRouteImport.update({
  id: '/profile-chats/',
  path: '/profile-chats/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOutreachIndexRoute = AdminOutreachIndexRouteImport.update({
  id: '/outreach/',
  path: '/outreach/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvestorsIndexRoute = AdminInvestorsIndexRouteImport.update({
  id: '/investors/',
  path: '/investors/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvestorIndexIndexRoute = AdminInvestorIndexIndexRouteImport.update({
  id: '/investor-index/',
  path: '/investor-index/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvestorChecksIndexRoute =
  AdminInvestorChecksIndexRouteImport.update({
    id: '/investor-checks/',
    path: '/investor-checks/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHelpCenterIndexRoute = AdminHelpCenterIndexRouteImport.update({
  id: '/help-center/',
  path: '/help-center/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsIndexRoute = AdminFeatureFlagsIndexRouteImport.update({
  id: '/feature-flags/',
  path: '/feature-flags/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEvaluationsIndexRoute = AdminEvaluationsIndexRouteImport.update({
  id: '/evaluations/',
  path: '/evaluations/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailsIndexRoute = AdminEmailsIndexRouteImport.update({
  id: '/emails/',
  path: '/emails/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailTemplatesIndexRoute =
  AdminEmailTemplatesIndexRouteImport.update({
    id: '/email-templates/',
    path: '/email-templates/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminDataRoomsIndexRoute = AdminDataRoomsIndexRouteImport.update({
  id: '/data-rooms/',
  path: '/data-rooms/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBlogIndexRoute = AdminBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAgentIndexRoute = AdminAgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => AdminRoute,
} as any)
const AppStartupIdRoute = AppStartupIdRouteImport.update({
  id: '/startup/$id',
  path: '/startup/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOauthLoginRoute = AppOauthLoginRouteImport.update({
  id: '/oauth/login',
  path: '/oauth/login',
  getParentRoute: () => AppRoute,
} as any)
const AppOauthConsentRoute = AppOauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => AppRoute,
} as any)
const AppInvestorIdRoute = AppInvestorIdRouteImport.update({
  id: '/investor/$id',
  path: '/investor/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppEvaluateStartupIdRoute = AppEvaluateStartupIdRouteImport.update({
  id: '/evaluate/$startupId',
  path: '/evaluate/$startupId',
  getParentRoute: () => AppRoute,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStartupsIdRoute = AdminStartupsIdRouteImport.update({
  id: '/startups/$id',
  path: '/startups/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileChatsConversationIdRoute =
  AdminProfileChatsConversationIdRouteImport.update({
    id: '/profile-chats/$conversationId',
    path: '/profile-chats/$conversationId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminOutreachReplyClassificationRoute =
  AdminOutreachReplyClassificationRouteImport.update({
    id: '/outreach/reply-classification',
    path: '/outreach/reply-classification',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsUpdateProposalsRoute =
  AdminInvestorsUpdateProposalsRouteImport.update({
    id: '/investors/update-proposals',
    path: '/investors/update-proposals',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsPortfolioResearchRoute =
  AdminInvestorsPortfolioResearchRouteImport.update({
    id: '/investors/portfolio-research',
    path: '/investors/portfolio-research',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsPersonaResearchRoute =
  AdminInvestorsPersonaResearchRouteImport.update({
    id: '/investors/persona-research',
    path: '/investors/persona-research',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsNormalizePreferencesRoute =
  AdminInvestorsNormalizePreferencesRouteImport.update({
    id: '/investors/normalize-preferences',
    path: '/investors/normalize-preferences',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsActivityResearchRoute =
  AdminInvestorsActivityResearchRouteImport.update({
    id: '/investors/activity-research',
    path: '/investors/activity-research',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvestorsIdRoute = AdminInvestorsIdRouteImport.update({
  id: '/investors/$id',
  path: '/investors/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHelpCenterNewRoute = AdminHelpCenterNewRouteImport.update({
  id: '/help-center/new',
  path: '/help-center/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHelpCenterIdRoute = AdminHelpCenterIdRouteImport.update({
  id: '/help-center/$id',
  path: '/help-center/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEvaluationsIdRoute = AdminEvaluationsIdRouteImport.update({
  id: '/evaluations/$id',
  path: '/evaluations/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailsIdRoute = AdminEmailsIdRouteImport.update({
  id: '/emails/$id',
  path: '/emails/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailTemplatesTypeRoute = AdminEmailTemplatesTypeRouteImport.update({
  id: '/email-templates/$type',
  path: '/email-templates/$type',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDataRoomsIdRoute = AdminDataRoomsIdRouteImport.update({
  id: '/data-rooms/$id',
  path: '/data-rooms/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBlogNewRoute = AdminBlogNewRouteImport.update({
  id: '/blog/new',
  path: '/blog/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBlogIdRoute = AdminBlogIdRouteImport.update({
  id: '/blog/$id',
  path: '/blog/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AppStartupIdIndexRoute = AppStartupIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppInvestorIdIndexRoute = AppInvestorIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AdminAgentObserversIndexRoute =
  AdminAgentObserversIndexRouteImport.update({
    id: '/agent/observers/',
    path: '/agent/observers/',
    getParentRoute: () => AdminRoute,
  } as any)
const AppStartupIdUpdatesRoute = AppStartupIdUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdSettingsRoute = AppStartupIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdProfileRoute = AppStartupIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdPreferencesRoute = AppStartupIdPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdPitchRoute = AppStartupIdPitchRouteImport.update({
  id: '/pitch',
  path: '/pitch',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdOutreachRoute = AppStartupIdOutreachRouteImport.update({
  id: '/outreach',
  path: '/outreach',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdMeRoute = AppStartupIdMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdInvestorsRoute = AppStartupIdInvestorsRouteImport.update({
  id: '/investors',
  path: '/investors',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdFeedRoute = AppStartupIdFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdBillingRoute = AppStartupIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdActivityRoute = AppStartupIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppInvestorIdWalletRoute = AppInvestorIdWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdSettingsRoute = AppInvestorIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdSearchRoute = AppInvestorIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdPrivacyRoute = AppInvestorIdPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdPreferencesRoute =
  AppInvestorIdPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdNotificationsRoute =
  AppInvestorIdNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdMeRoute = AppInvestorIdMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdFollowsRoute = AppInvestorIdFollowsRouteImport.update({
  id: '/follows',
  path: '/follows',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdFeedRoute = AppInvestorIdFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdDealFlowRoute = AppInvestorIdDealFlowRouteImport.update({
  id: '/deal-flow',
  path: '/deal-flow',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdCreditsRoute = AppInvestorIdCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppInvestorIdConnectAiRoute = AppInvestorIdConnectAiRouteImport.update({
  id: '/connect-ai',
  path: '/connect-ai',
  getParentRoute: () => AppInvestorIdRoute,
} as any)
const AppStartupIdProfileIndexRoute =
  AppStartupIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStartupIdProfileRoute,
  } as any)
const AppStartupIdOutreachIndexRoute =
  AppStartupIdOutreachIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStartupIdOutreachRoute,
  } as any)
const AppStartupIdSettingsBillingRoute =
  AppStartupIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppStartupIdSettingsRoute,
  } as any)
const AppStartupIdSettingsAnalyticsRoute =
  AppStartupIdSettingsAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppStartupIdSettingsRoute,
  } as any)
const AppStartupIdProfileLinksRoute =
  AppStartupIdProfileLinksRouteImport.update({
    id: '/links',
    path: '/links',
    getParentRoute: () => AppStartupIdProfileRoute,
  } as any)
const AppStartupIdProfileDeepInsightsRoute =
  AppStartupIdProfileDeepInsightsRouteImport.update({
    id: '/deep-insights',
    path: '/deep-insights',
    getParentRoute: () => AppStartupIdProfileRoute,
  } as any)
const AppStartupIdProfileAnalyticsRoute =
  AppStartupIdProfileAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppStartupIdProfileRoute,
  } as any)
const AppStartupIdPitchStartRoute = AppStartupIdPitchStartRouteImport.update({
  id: '/pitch_/start',
  path: '/pitch/start',
  getParentRoute: () => AppStartupIdRoute,
} as any)
const AppStartupIdOutreachRepliesRoute =
  AppStartupIdOutreachRepliesRouteImport.update({
    id: '/replies',
    path: '/replies',
    getParentRoute: () => AppStartupIdOutreachRoute,
  } as any)
const AppStartupIdOutreachArchiveRoute =
  AppStartupIdOutreachArchiveRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => AppStartupIdOutreachRoute,
  } as any)
const AppStartupIdEvaluationEvaluationIdRoute =
  AppStartupIdEvaluationEvaluationIdRouteImport.update({
    id: '/evaluation/$evaluationId',
    path: '/evaluation/$evaluationId',
    getParentRoute: () => AppStartupIdRoute,
  } as any)
const AppInvestorIdStartupTokenRoute =
  AppInvestorIdStartupTokenRouteImport.update({
    id: '/startup/$token',
    path: '/startup/$token',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdEvaluationEvaluationIdRoute =
  AppInvestorIdEvaluationEvaluationIdRouteImport.update({
    id: '/evaluation/$evaluationId',
    path: '/evaluation/$evaluationId',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdEvaluateStartupIdRoute =
  AppInvestorIdEvaluateStartupIdRouteImport.update({
    id: '/evaluate/$startupId',
    path: '/evaluate/$startupId',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdDealFlowArchiveRoute =
  AppInvestorIdDealFlowArchiveRouteImport.update({
    id: '/deal-flow_/archive',
    path: '/deal-flow/archive',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AppInvestorIdDealFlowStartupIdRoute =
  AppInvestorIdDealFlowStartupIdRouteImport.update({
    id: '/deal-flow_/$startupId',
    path: '/deal-flow/$startupId',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)
const AdminEvaluationsIdJudgeJudgeKeyRoute =
  AdminEvaluationsIdJudgeJudgeKeyRouteImport.update({
    id: '/judge/$judgeKey',
    path: '/judge/$judgeKey',
    getParentRoute: () => AdminEvaluationsIdRoute,
  } as any)
const AppStartupIdJudgeJudgeKeyEvaluationIdRoute =
  AppStartupIdJudgeJudgeKeyEvaluationIdRouteImport.update({
    id: '/judge/$judgeKey/$evaluationId',
    path: '/judge/$judgeKey/$evaluationId',
    getParentRoute: () => AppStartupIdRoute,
  } as any)
const AppInvestorIdJudgeJudgeKeyEvaluationIdRoute =
  AppInvestorIdJudgeJudgeKeyEvaluationIdRouteImport.update({
    id: '/judge/$judgeKey/$evaluationId',
    path: '/judge/$judgeKey/$evaluationId',
    getParentRoute: () => AppInvestorIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/admin/matcher-jobs': typeof AdminMatcherJobsRoute
  '/app/connect-ai': typeof AppConnectAiRoute
  '/dev/heyreach': typeof DevHeyreachRoute
  '/i/$token': typeof ITokenRoute
  '/s/$token': typeof STokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/blog/$id': typeof AdminBlogIdRoute
  '/admin/blog/new': typeof AdminBlogNewRoute
  '/admin/data-rooms/$id': typeof AdminDataRoomsIdRoute
  '/admin/email-templates/$type': typeof AdminEmailTemplatesTypeRoute
  '/admin/emails/$id': typeof AdminEmailsIdRoute
  '/admin/evaluations/$id': typeof AdminEvaluationsIdRouteWithChildren
  '/admin/help-center/$id': typeof AdminHelpCenterIdRoute
  '/admin/help-center/new': typeof AdminHelpCenterNewRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/admin/investors/activity-research': typeof AdminInvestorsActivityResearchRoute
  '/admin/investors/normalize-preferences': typeof AdminInvestorsNormalizePreferencesRoute
  '/admin/investors/persona-research': typeof AdminInvestorsPersonaResearchRoute
  '/admin/investors/portfolio-research': typeof AdminInvestorsPortfolioResearchRoute
  '/admin/investors/update-proposals': typeof AdminInvestorsUpdateProposalsRoute
  '/admin/outreach/reply-classification': typeof AdminOutreachReplyClassificationRoute
  '/admin/profile-chats/$conversationId': typeof AdminProfileChatsConversationIdRoute
  '/admin/startups/$id': typeof AdminStartupsIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/app/evaluate/$startupId': typeof AppEvaluateStartupIdRoute
  '/app/investor/$id': typeof AppInvestorIdRouteWithChildren
  '/app/oauth/consent': typeof AppOauthConsentRoute
  '/app/oauth/login': typeof AppOauthLoginRoute
  '/app/startup/$id': typeof AppStartupIdRouteWithChildren
  '/admin/agent': typeof AdminAgentIndexRoute
  '/admin/blog': typeof AdminBlogIndexRoute
  '/admin/data-rooms': typeof AdminDataRoomsIndexRoute
  '/admin/email-templates': typeof AdminEmailTemplatesIndexRoute
  '/admin/emails': typeof AdminEmailsIndexRoute
  '/admin/evaluations': typeof AdminEvaluationsIndexRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/help-center': typeof AdminHelpCenterIndexRoute
  '/admin/investor-checks': typeof AdminInvestorChecksIndexRoute
  '/admin/investor-index': typeof AdminInvestorIndexIndexRoute
  '/admin/investors': typeof AdminInvestorsIndexRoute
  '/admin/outreach': typeof AdminOutreachIndexRoute
  '/admin/profile-chats': typeof AdminProfileChatsIndexRoute
  '/admin/signup-question': typeof AdminSignupQuestionIndexRoute
  '/admin/startups': typeof AdminStartupsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/app/investor/$id/connect-ai': typeof AppInvestorIdConnectAiRoute
  '/app/investor/$id/credits': typeof AppInvestorIdCreditsRoute
  '/app/investor/$id/deal-flow': typeof AppInvestorIdDealFlowRoute
  '/app/investor/$id/feed': typeof AppInvestorIdFeedRoute
  '/app/investor/$id/follows': typeof AppInvestorIdFollowsRoute
  '/app/investor/$id/me': typeof AppInvestorIdMeRoute
  '/app/investor/$id/notifications': typeof AppInvestorIdNotificationsRoute
  '/app/investor/$id/preferences': typeof AppInvestorIdPreferencesRoute
  '/app/investor/$id/privacy': typeof AppInvestorIdPrivacyRoute
  '/app/investor/$id/search': typeof AppInvestorIdSearchRoute
  '/app/investor/$id/settings': typeof AppInvestorIdSettingsRoute
  '/app/investor/$id/wallet': typeof AppInvestorIdWalletRoute
  '/app/startup/$id/activity': typeof AppStartupIdActivityRoute
  '/app/startup/$id/billing': typeof AppStartupIdBillingRoute
  '/app/startup/$id/feed': typeof AppStartupIdFeedRoute
  '/app/startup/$id/investors': typeof AppStartupIdInvestorsRoute
  '/app/startup/$id/me': typeof AppStartupIdMeRoute
  '/app/startup/$id/outreach': typeof AppStartupIdOutreachRouteWithChildren
  '/app/startup/$id/pitch': typeof AppStartupIdPitchRoute
  '/app/startup/$id/preferences': typeof AppStartupIdPreferencesRoute
  '/app/startup/$id/profile': typeof AppStartupIdProfileRouteWithChildren
  '/app/startup/$id/settings': typeof AppStartupIdSettingsRouteWithChildren
  '/app/startup/$id/updates': typeof AppStartupIdUpdatesRoute
  '/admin/agent/observers': typeof AdminAgentObserversIndexRoute
  '/app/investor/$id/': typeof AppInvestorIdIndexRoute
  '/app/startup/$id/': typeof AppStartupIdIndexRoute
  '/admin/evaluations/$id/judge/$judgeKey': typeof AdminEvaluationsIdJudgeJudgeKeyRoute
  '/app/investor/$id/deal-flow/$startupId': typeof AppInvestorIdDealFlowStartupIdRoute
  '/app/investor/$id/deal-flow/archive': typeof AppInvestorIdDealFlowArchiveRoute
  '/app/investor/$id/evaluate/$startupId': typeof AppInvestorIdEvaluateStartupIdRoute
  '/app/investor/$id/evaluation/$evaluationId': typeof AppInvestorIdEvaluationEvaluationIdRoute
  '/app/investor/$id/startup/$token': typeof AppInvestorIdStartupTokenRoute
  '/app/startup/$id/evaluation/$evaluationId': typeof AppStartupIdEvaluationEvaluationIdRoute
  '/app/startup/$id/outreach/archive': typeof AppStartupIdOutreachArchiveRoute
  '/app/startup/$id/outreach/replies': typeof AppStartupIdOutreachRepliesRoute
  '/app/startup/$id/pitch/start': typeof AppStartupIdPitchStartRoute
  '/app/startup/$id/profile/analytics': typeof AppStartupIdProfileAnalyticsRoute
  '/app/startup/$id/profile/deep-insights': typeof AppStartupIdProfileDeepInsightsRoute
  '/app/startup/$id/profile/links': typeof AppStartupIdProfileLinksRoute
  '/app/startup/$id/settings/analytics': typeof AppStartupIdSettingsAnalyticsRoute
  '/app/startup/$id/settings/billing': typeof AppStartupIdSettingsBillingRoute
  '/app/startup/$id/outreach/': typeof AppStartupIdOutreachIndexRoute
  '/app/startup/$id/profile/': typeof AppStartupIdProfileIndexRoute
  '/app/investor/$id/judge/$judgeKey/$evaluationId': typeof AppInvestorIdJudgeJudgeKeyEvaluationIdRoute
  '/app/startup/$id/judge/$judgeKey/$evaluationId': typeof AppStartupIdJudgeJudgeKeyEvaluationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/admin/matcher-jobs': typeof AdminMatcherJobsRoute
  '/app/connect-ai': typeof AppConnectAiRoute
  '/dev/heyreach': typeof DevHeyreachRoute
  '/i/$token': typeof ITokenRoute
  '/s/$token': typeof STokenRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/admin/blog/$id': typeof AdminBlogIdRoute
  '/admin/blog/new': typeof AdminBlogNewRoute
  '/admin/data-rooms/$id': typeof AdminDataRoomsIdRoute
  '/admin/email-templates/$type': typeof AdminEmailTemplatesTypeRoute
  '/admin/emails/$id': typeof AdminEmailsIdRoute
  '/admin/evaluations/$id': typeof AdminEvaluationsIdRouteWithChildren
  '/admin/help-center/$id': typeof AdminHelpCenterIdRoute
  '/admin/help-center/new': typeof AdminHelpCenterNewRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/admin/investors/activity-research': typeof AdminInvestorsActivityResearchRoute
  '/admin/investors/normalize-preferences': typeof AdminInvestorsNormalizePreferencesRoute
  '/admin/investors/persona-research': typeof AdminInvestorsPersonaResearchRoute
  '/admin/investors/portfolio-research': typeof AdminInvestorsPortfolioResearchRoute
  '/admin/investors/update-proposals': typeof AdminInvestorsUpdateProposalsRoute
  '/admin/outreach/reply-classification': typeof AdminOutreachReplyClassificationRoute
  '/admin/profile-chats/$conversationId': typeof AdminProfileChatsConversationIdRoute
  '/admin/startups/$id': typeof AdminStartupsIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/app/evaluate/$startupId': typeof AppEvaluateStartupIdRoute
  '/app/oauth/consent': typeof AppOauthConsentRoute
  '/app/oauth/login': typeof AppOauthLoginRoute
  '/admin/agent': typeof AdminAgentIndexRoute
  '/admin/blog': typeof AdminBlogIndexRoute
  '/admin/data-rooms': typeof AdminDataRoomsIndexRoute
  '/admin/email-templates': typeof AdminEmailTemplatesIndexRoute
  '/admin/emails': typeof AdminEmailsIndexRoute
  '/admin/evaluations': typeof AdminEvaluationsIndexRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/help-center': typeof AdminHelpCenterIndexRoute
  '/admin/investor-checks': typeof AdminInvestorChecksIndexRoute
  '/admin/investor-index': typeof AdminInvestorIndexIndexRoute
  '/admin/investors': typeof AdminInvestorsIndexRoute
  '/admin/outreach': typeof AdminOutreachIndexRoute
  '/admin/profile-chats': typeof AdminProfileChatsIndexRoute
  '/admin/signup-question': typeof AdminSignupQuestionIndexRoute
  '/admin/startups': typeof AdminStartupsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/app/investor/$id/connect-ai': typeof AppInvestorIdConnectAiRoute
  '/app/investor/$id/credits': typeof AppInvestorIdCreditsRoute
  '/app/investor/$id/deal-flow': typeof AppInvestorIdDealFlowRoute
  '/app/investor/$id/feed': typeof AppInvestorIdFeedRoute
  '/app/investor/$id/follows': typeof AppInvestorIdFollowsRoute
  '/app/investor/$id/me': typeof AppInvestorIdMeRoute
  '/app/investor/$id/notifications': typeof AppInvestorIdNotificationsRoute
  '/app/investor/$id/preferences': typeof AppInvestorIdPreferencesRoute
  '/app/investor/$id/privacy': typeof AppInvestorIdPrivacyRoute
  '/app/investor/$id/search': typeof AppInvestorIdSearchRoute
  '/app/investor/$id/settings': typeof AppInvestorIdSettingsRoute
  '/app/investor/$id/wallet': typeof AppInvestorIdWalletRoute
  '/app/startup/$id/activity': typeof AppStartupIdActivityRoute
  '/app/startup/$id/billing': typeof AppStartupIdBillingRoute
  '/app/startup/$id/feed': typeof AppStartupIdFeedRoute
  '/app/startup/$id/investors': typeof AppStartupIdInvestorsRoute
  '/app/startup/$id/me': typeof AppStartupIdMeRoute
  '/app/startup/$id/pitch': typeof AppStartupIdPitchRoute
  '/app/startup/$id/preferences': typeof AppStartupIdPreferencesRoute
  '/app/startup/$id/settings': typeof AppStartupIdSettingsRouteWithChildren
  '/app/startup/$id/updates': typeof AppStartupIdUpdatesRoute
  '/admin/agent/observers': typeof AdminAgentObserversIndexRoute
  '/app/investor/$id': typeof AppInvestorIdIndexRoute
  '/app/startup/$id': typeof AppStartupIdIndexRoute
  '/admin/evaluations/$id/judge/$judgeKey': typeof AdminEvaluationsIdJudgeJudgeKeyRoute
  '/app/investor/$id/deal-flow/$startupId': typeof AppInvestorIdDealFlowStartupIdRoute
  '/app/investor/$id/deal-flow/archive': typeof AppInvestorIdDealFlowArchiveRoute
  '/app/investor/$id/evaluate/$startupId': typeof AppInvestorIdEvaluateStartupIdRoute
  '/app/investor/$id/evaluation/$evaluationId': typeof AppInvestorIdEvaluationEvaluationIdRoute
  '/app/investor/$id/startup/$token': typeof AppInvestorIdStartupTokenRoute
  '/app/startup/$id/evaluation/$evaluationId': typeof AppStartupIdEvaluationEvaluationIdRoute
  '/app/startup/$id/outreach/archive': typeof AppStartupIdOutreachArchiveRoute
  '/app/startup/$id/outreach/replies': typeof AppStartupIdOutreachRepliesRoute
  '/app/startup/$id/pitch/start': typeof AppStartupIdPitchStartRoute
  '/app/startup/$id/profile/analytics': typeof AppStartupIdProfileAnalyticsRoute
  '/app/startup/$id/profile/deep-insights': typeof AppStartupIdProfileDeepInsightsRoute
  '/app/startup/$id/profile/links': typeof AppStartupIdProfileLinksRoute
  '/app/startup/$id/settings/analytics': typeof AppStartupIdSettingsAnalyticsRoute
  '/app/startup/$id/settings/billing': typeof AppStartupIdSettingsBillingRoute
  '/app/startup/$id/outreach': typeof AppStartupIdOutreachIndexRoute
  '/app/startup/$id/profile': typeof AppStartupIdProfileIndexRoute
  '/app/investor/$id/judge/$judgeKey/$evaluationId': typeof AppInvestorIdJudgeJudgeKeyEvaluationIdRoute
  '/app/startup/$id/judge/$judgeKey/$evaluationId': typeof AppStartupIdJudgeJudgeKeyEvaluationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/admin/matcher-jobs': typeof AdminMatcherJobsRoute
  '/app/connect-ai': typeof AppConnectAiRoute
  '/dev/heyreach': typeof DevHeyreachRoute
  '/i/$token': typeof ITokenRoute
  '/s/$token': typeof STokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/blog/$id': typeof AdminBlogIdRoute
  '/admin/blog/new': typeof AdminBlogNewRoute
  '/admin/data-rooms/$id': typeof AdminDataRoomsIdRoute
  '/admin/email-templates/$type': typeof AdminEmailTemplatesTypeRoute
  '/admin/emails/$id': typeof AdminEmailsIdRoute
  '/admin/evaluations/$id': typeof AdminEvaluationsIdRouteWithChildren
  '/admin/help-center/$id': typeof AdminHelpCenterIdRoute
  '/admin/help-center/new': typeof AdminHelpCenterNewRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/admin/investors/activity-research': typeof AdminInvestorsActivityResearchRoute
  '/admin/investors/normalize-preferences': typeof AdminInvestorsNormalizePreferencesRoute
  '/admin/investors/persona-research': typeof AdminInvestorsPersonaResearchRoute
  '/admin/investors/portfolio-research': typeof AdminInvestorsPortfolioResearchRoute
  '/admin/investors/update-proposals': typeof AdminInvestorsUpdateProposalsRoute
  '/admin/outreach/reply-classification': typeof AdminOutreachReplyClassificationRoute
  '/admin/profile-chats/$conversationId': typeof AdminProfileChatsConversationIdRoute
  '/admin/startups/$id': typeof AdminStartupsIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/app/evaluate/$startupId': typeof AppEvaluateStartupIdRoute
  '/app/investor/$id': typeof AppInvestorIdRouteWithChildren
  '/app/oauth/consent': typeof AppOauthConsentRoute
  '/app/oauth/login': typeof AppOauthLoginRoute
  '/app/startup/$id': typeof AppStartupIdRouteWithChildren
  '/admin/agent/': typeof AdminAgentIndexRoute
  '/admin/blog/': typeof AdminBlogIndexRoute
  '/admin/data-rooms/': typeof AdminDataRoomsIndexRoute
  '/admin/email-templates/': typeof AdminEmailTemplatesIndexRoute
  '/admin/emails/': typeof AdminEmailsIndexRoute
  '/admin/evaluations/': typeof AdminEvaluationsIndexRoute
  '/admin/feature-flags/': typeof AdminFeatureFlagsIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/help-center/': typeof AdminHelpCenterIndexRoute
  '/admin/investor-checks/': typeof AdminInvestorChecksIndexRoute
  '/admin/investor-index/': typeof AdminInvestorIndexIndexRoute
  '/admin/investors/': typeof AdminInvestorsIndexRoute
  '/admin/outreach/': typeof AdminOutreachIndexRoute
  '/admin/profile-chats/': typeof AdminProfileChatsIndexRoute
  '/admin/signup-question/': typeof AdminSignupQuestionIndexRoute
  '/admin/startups/': typeof AdminStartupsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/app/investor/$id/connect-ai': typeof AppInvestorIdConnectAiRoute
  '/app/investor/$id/credits': typeof AppInvestorIdCreditsRoute
  '/app/investor/$id/deal-flow': typeof AppInvestorIdDealFlowRoute
  '/app/investor/$id/feed': typeof AppInvestorIdFeedRoute
  '/app/investor/$id/follows': typeof AppInvestorIdFollowsRoute
  '/app/investor/$id/me': typeof AppInvestorIdMeRoute
  '/app/investor/$id/notifications': typeof AppInvestorIdNotificationsRoute
  '/app/investor/$id/preferences': typeof AppInvestorIdPreferencesRoute
  '/app/investor/$id/privacy': typeof AppInvestorIdPrivacyRoute
  '/app/investor/$id/search': typeof AppInvestorIdSearchRoute
  '/app/investor/$id/settings': typeof AppInvestorIdSettingsRoute
  '/app/investor/$id/wallet': typeof AppInvestorIdWalletRoute
  '/app/startup/$id/activity': typeof AppStartupIdActivityRoute
  '/app/startup/$id/billing': typeof AppStartupIdBillingRoute
  '/app/startup/$id/feed': typeof AppStartupIdFeedRoute
  '/app/startup/$id/investors': typeof AppStartupIdInvestorsRoute
  '/app/startup/$id/me': typeof AppStartupIdMeRoute
  '/app/startup/$id/outreach': typeof AppStartupIdOutreachRouteWithChildren
  '/app/startup/$id/pitch': typeof AppStartupIdPitchRoute
  '/app/startup/$id/preferences': typeof AppStartupIdPreferencesRoute
  '/app/startup/$id/profile': typeof AppStartupIdProfileRouteWithChildren
  '/app/startup/$id/settings': typeof AppStartupIdSettingsRouteWithChildren
  '/app/startup/$id/updates': typeof AppStartupIdUpdatesRoute
  '/admin/agent/observers/': typeof AdminAgentObserversIndexRoute
  '/app/investor/$id/': typeof AppInvestorIdIndexRoute
  '/app/startup/$id/': typeof AppStartupIdIndexRoute
  '/admin/evaluations/$id/judge/$judgeKey': typeof AdminEvaluationsIdJudgeJudgeKeyRoute
  '/app/investor/$id/deal-flow_/$startupId': typeof AppInvestorIdDealFlowStartupIdRoute
  '/app/investor/$id/deal-flow_/archive': typeof AppInvestorIdDealFlowArchiveRoute
  '/app/investor/$id/evaluate/$startupId': typeof AppInvestorIdEvaluateStartupIdRoute
  '/app/investor/$id/evaluation/$evaluationId': typeof AppInvestorIdEvaluationEvaluationIdRoute
  '/app/investor/$id/startup/$token': typeof AppInvestorIdStartupTokenRoute
  '/app/startup/$id/evaluation/$evaluationId': typeof AppStartupIdEvaluationEvaluationIdRoute
  '/app/startup/$id/outreach/archive': typeof AppStartupIdOutreachArchiveRoute
  '/app/startup/$id/outreach/replies': typeof AppStartupIdOutreachRepliesRoute
  '/app/startup/$id/pitch_/start': typeof AppStartupIdPitchStartRoute
  '/app/startup/$id/profile/analytics': typeof AppStartupIdProfileAnalyticsRoute
  '/app/startup/$id/profile/deep-insights': typeof AppStartupIdProfileDeepInsightsRoute
  '/app/startup/$id/profile/links': typeof AppStartupIdProfileLinksRoute
  '/app/startup/$id/settings/analytics': typeof AppStartupIdSettingsAnalyticsRoute
  '/app/startup/$id/settings/billing': typeof AppStartupIdSettingsBillingRoute
  '/app/startup/$id/outreach/': typeof AppStartupIdOutreachIndexRoute
  '/app/startup/$id/profile/': typeof AppStartupIdProfileIndexRoute
  '/app/investor/$id/judge/$judgeKey/$evaluationId': typeof AppInvestorIdJudgeJudgeKeyEvaluationIdRoute
  '/app/startup/$id/judge/$judgeKey/$evaluationId': typeof AppStartupIdJudgeJudgeKeyEvaluationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/admin'
    | '/app'
    | '/livekit-egress-template'
    | '/admin/matcher-jobs'
    | '/app/connect-ai'
    | '/dev/heyreach'
    | '/i/$token'
    | '/s/$token'
    | '/admin/'
    | '/app/'
    | '/admin/blog/$id'
    | '/admin/blog/new'
    | '/admin/data-rooms/$id'
    | '/admin/email-templates/$type'
    | '/admin/emails/$id'
    | '/admin/evaluations/$id'
    | '/admin/help-center/$id'
    | '/admin/help-center/new'
    | '/admin/investors/$id'
    | '/admin/investors/activity-research'
    | '/admin/investors/normalize-preferences'
    | '/admin/investors/persona-research'
    | '/admin/investors/portfolio-research'
    | '/admin/investors/update-proposals'
    | '/admin/outreach/reply-classification'
    | '/admin/profile-chats/$conversationId'
    | '/admin/startups/$id'
    | '/admin/users/$id'
    | '/app/evaluate/$startupId'
    | '/app/investor/$id'
    | '/app/oauth/consent'
    | '/app/oauth/login'
    | '/app/startup/$id'
    | '/admin/agent'
    | '/admin/blog'
    | '/admin/data-rooms'
    | '/admin/email-templates'
    | '/admin/emails'
    | '/admin/evaluations'
    | '/admin/feature-flags'
    | '/admin/feedback'
    | '/admin/help-center'
    | '/admin/investor-checks'
    | '/admin/investor-index'
    | '/admin/investors'
    | '/admin/outreach'
    | '/admin/profile-chats'
    | '/admin/signup-question'
    | '/admin/startups'
    | '/admin/users'
    | '/app/investor/$id/connect-ai'
    | '/app/investor/$id/credits'
    | '/app/investor/$id/deal-flow'
    | '/app/investor/$id/feed'
    | '/app/investor/$id/follows'
    | '/app/investor/$id/me'
    | '/app/investor/$id/notifications'
    | '/app/investor/$id/preferences'
    | '/app/investor/$id/privacy'
    | '/app/investor/$id/search'
    | '/app/investor/$id/settings'
    | '/app/investor/$id/wallet'
    | '/app/startup/$id/activity'
    | '/app/startup/$id/billing'
    | '/app/startup/$id/feed'
    | '/app/startup/$id/investors'
    | '/app/startup/$id/me'
    | '/app/startup/$id/outreach'
    | '/app/startup/$id/pitch'
    | '/app/startup/$id/preferences'
    | '/app/startup/$id/profile'
    | '/app/startup/$id/settings'
    | '/app/startup/$id/updates'
    | '/admin/agent/observers'
    | '/app/investor/$id/'
    | '/app/startup/$id/'
    | '/admin/evaluations/$id/judge/$judgeKey'
    | '/app/investor/$id/deal-flow/$startupId'
    | '/app/investor/$id/deal-flow/archive'
    | '/app/investor/$id/evaluate/$startupId'
    | '/app/investor/$id/evaluation/$evaluationId'
    | '/app/investor/$id/startup/$token'
    | '/app/startup/$id/evaluation/$evaluationId'
    | '/app/startup/$id/outreach/archive'
    | '/app/startup/$id/outreach/replies'
    | '/app/startup/$id/pitch/start'
    | '/app/startup/$id/profile/analytics'
    | '/app/startup/$id/profile/deep-insights'
    | '/app/startup/$id/profile/links'
    | '/app/startup/$id/settings/analytics'
    | '/app/startup/$id/settings/billing'
    | '/app/startup/$id/outreach/'
    | '/app/startup/$id/profile/'
    | '/app/investor/$id/judge/$judgeKey/$evaluationId'
    | '/app/startup/$id/judge/$judgeKey/$evaluationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug'
    | '/livekit-egress-template'
    | '/admin/matcher-jobs'
    | '/app/connect-ai'
    | '/dev/heyreach'
    | '/i/$token'
    | '/s/$token'
    | '/admin'
    | '/app'
    | '/admin/blog/$id'
    | '/admin/blog/new'
    | '/admin/data-rooms/$id'
    | '/admin/email-templates/$type'
    | '/admin/emails/$id'
    | '/admin/evaluations/$id'
    | '/admin/help-center/$id'
    | '/admin/help-center/new'
    | '/admin/investors/$id'
    | '/admin/investors/activity-research'
    | '/admin/investors/normalize-preferences'
    | '/admin/investors/persona-research'
    | '/admin/investors/portfolio-research'
    | '/admin/investors/update-proposals'
    | '/admin/outreach/reply-classification'
    | '/admin/profile-chats/$conversationId'
    | '/admin/startups/$id'
    | '/admin/users/$id'
    | '/app/evaluate/$startupId'
    | '/app/oauth/consent'
    | '/app/oauth/login'
    | '/admin/agent'
    | '/admin/blog'
    | '/admin/data-rooms'
    | '/admin/email-templates'
    | '/admin/emails'
    | '/admin/evaluations'
    | '/admin/feature-flags'
    | '/admin/feedback'
    | '/admin/help-center'
    | '/admin/investor-checks'
    | '/admin/investor-index'
    | '/admin/investors'
    | '/admin/outreach'
    | '/admin/profile-chats'
    | '/admin/signup-question'
    | '/admin/startups'
    | '/admin/users'
    | '/app/investor/$id/connect-ai'
    | '/app/investor/$id/credits'
    | '/app/investor/$id/deal-flow'
    | '/app/investor/$id/feed'
    | '/app/investor/$id/follows'
    | '/app/investor/$id/me'
    | '/app/investor/$id/notifications'
    | '/app/investor/$id/preferences'
    | '/app/investor/$id/privacy'
    | '/app/investor/$id/search'
    | '/app/investor/$id/settings'
    | '/app/investor/$id/wallet'
    | '/app/startup/$id/activity'
    | '/app/startup/$id/billing'
    | '/app/startup/$id/feed'
    | '/app/startup/$id/investors'
    | '/app/startup/$id/me'
    | '/app/startup/$id/pitch'
    | '/app/startup/$id/preferences'
    | '/app/startup/$id/settings'
    | '/app/startup/$id/updates'
    | '/admin/agent/observers'
    | '/app/investor/$id'
    | '/app/startup/$id'
    | '/admin/evaluations/$id/judge/$judgeKey'
    | '/app/investor/$id/deal-flow/$startupId'
    | '/app/investor/$id/deal-flow/archive'
    | '/app/investor/$id/evaluate/$startupId'
    | '/app/investor/$id/evaluation/$evaluationId'
    | '/app/investor/$id/startup/$token'
    | '/app/startup/$id/evaluation/$evaluationId'
    | '/app/startup/$id/outreach/archive'
    | '/app/startup/$id/outreach/replies'
    | '/app/startup/$id/pitch/start'
    | '/app/startup/$id/profile/analytics'
    | '/app/startup/$id/profile/deep-insights'
    | '/app/startup/$id/profile/links'
    | '/app/startup/$id/settings/analytics'
    | '/app/startup/$id/settings/billing'
    | '/app/startup/$id/outreach'
    | '/app/startup/$id/profile'
    | '/app/investor/$id/judge/$judgeKey/$evaluationId'
    | '/app/startup/$id/judge/$judgeKey/$evaluationId'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/admin'
    | '/app'
    | '/livekit-egress-template'
    | '/admin/matcher-jobs'
    | '/app/connect-ai'
    | '/dev/heyreach'
    | '/i/$token'
    | '/s/$token'
    | '/admin/'
    | '/app/'
    | '/admin/blog/$id'
    | '/admin/blog/new'
    | '/admin/data-rooms/$id'
    | '/admin/email-templates/$type'
    | '/admin/emails/$id'
    | '/admin/evaluations/$id'
    | '/admin/help-center/$id'
    | '/admin/help-center/new'
    | '/admin/investors/$id'
    | '/admin/investors/activity-research'
    | '/admin/investors/normalize-preferences'
    | '/admin/investors/persona-research'
    | '/admin/investors/portfolio-research'
    | '/admin/investors/update-proposals'
    | '/admin/outreach/reply-classification'
    | '/admin/profile-chats/$conversationId'
    | '/admin/startups/$id'
    | '/admin/users/$id'
    | '/app/evaluate/$startupId'
    | '/app/investor/$id'
    | '/app/oauth/consent'
    | '/app/oauth/login'
    | '/app/startup/$id'
    | '/admin/agent/'
    | '/admin/blog/'
    | '/admin/data-rooms/'
    | '/admin/email-templates/'
    | '/admin/emails/'
    | '/admin/evaluations/'
    | '/admin/feature-flags/'
    | '/admin/feedback/'
    | '/admin/help-center/'
    | '/admin/investor-checks/'
    | '/admin/investor-index/'
    | '/admin/investors/'
    | '/admin/outreach/'
    | '/admin/profile-chats/'
    | '/admin/signup-question/'
    | '/admin/startups/'
    | '/admin/users/'
    | '/app/investor/$id/connect-ai'
    | '/app/investor/$id/credits'
    | '/app/investor/$id/deal-flow'
    | '/app/investor/$id/feed'
    | '/app/investor/$id/follows'
    | '/app/investor/$id/me'
    | '/app/investor/$id/notifications'
    | '/app/investor/$id/preferences'
    | '/app/investor/$id/privacy'
    | '/app/investor/$id/search'
    | '/app/investor/$id/settings'
    | '/app/investor/$id/wallet'
    | '/app/startup/$id/activity'
    | '/app/startup/$id/billing'
    | '/app/startup/$id/feed'
    | '/app/startup/$id/investors'
    | '/app/startup/$id/me'
    | '/app/startup/$id/outreach'
    | '/app/startup/$id/pitch'
    | '/app/startup/$id/preferences'
    | '/app/startup/$id/profile'
    | '/app/startup/$id/settings'
    | '/app/startup/$id/updates'
    | '/admin/agent/observers/'
    | '/app/investor/$id/'
    | '/app/startup/$id/'
    | '/admin/evaluations/$id/judge/$judgeKey'
    | '/app/investor/$id/deal-flow_/$startupId'
    | '/app/investor/$id/deal-flow_/archive'
    | '/app/investor/$id/evaluate/$startupId'
    | '/app/investor/$id/evaluation/$evaluationId'
    | '/app/investor/$id/startup/$token'
    | '/app/startup/$id/evaluation/$evaluationId'
    | '/app/startup/$id/outreach/archive'
    | '/app/startup/$id/outreach/replies'
    | '/app/startup/$id/pitch_/start'
    | '/app/startup/$id/profile/analytics'
    | '/app/startup/$id/profile/deep-insights'
    | '/app/startup/$id/profile/links'
    | '/app/startup/$id/settings/analytics'
    | '/app/startup/$id/settings/billing'
    | '/app/startup/$id/outreach/'
    | '/app/startup/$id/profile/'
    | '/app/investor/$id/judge/$judgeKey/$evaluationId'
    | '/app/startup/$id/judge/$judgeKey/$evaluationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LivekitEgressTemplateRoute: typeof LivekitEgressTemplateRoute
  DevHeyreachRoute: typeof DevHeyreachRoute
  ITokenRoute: typeof ITokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/livekit-egress-template': {
      id: '/livekit-egress-template'
      path: '/livekit-egress-template'
      fullPath: '/livekit-egress-template'
      preLoaderRoute: typeof LivekitEgressTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/heyreach': {
      id: '/dev/heyreach'
      path: '/dev/heyreach'
      fullPath: '/dev/heyreach'
      preLoaderRoute: typeof DevHeyreachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/connect-ai': {
      id: '/app/connect-ai'
      path: '/connect-ai'
      fullPath: '/app/connect-ai'
      preLoaderRoute: typeof AppConnectAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/matcher-jobs': {
      id: '/admin/matcher-jobs'
      path: '/matcher-jobs'
      fullPath: '/admin/matcher-jobs'
      preLoaderRoute: typeof AdminMatcherJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/startups/': {
      id: '/admin/startups/'
      path: '/startups'
      fullPath: '/admin/startups'
      preLoaderRoute: typeof AdminStartupsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/signup-question/': {
      id: '/admin/signup-question/'
      path: '/signup-question'
      fullPath: '/admin/signup-question'
      preLoaderRoute: typeof AdminSignupQuestionIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile-chats/': {
      id: '/admin/profile-chats/'
      path: '/profile-chats'
      fullPath: '/admin/profile-chats'
      preLoaderRoute: typeof AdminProfileChatsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/outreach/': {
      id: '/admin/outreach/'
      path: '/outreach'
      fullPath: '/admin/outreach'
      preLoaderRoute: typeof AdminOutreachIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/': {
      id: '/admin/investors/'
      path: '/investors'
      fullPath: '/admin/investors'
      preLoaderRoute: typeof AdminInvestorsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investor-index/': {
      id: '/admin/investor-index/'
      path: '/investor-index'
      fullPath: '/admin/investor-index'
      preLoaderRoute: typeof AdminInvestorIndexIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investor-checks/': {
      id: '/admin/investor-checks/'
      path: '/investor-checks'
      fullPath: '/admin/investor-checks'
      preLoaderRoute: typeof AdminInvestorChecksIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-center/': {
      id: '/admin/help-center/'
      path: '/help-center'
      fullPath: '/admin/help-center'
      preLoaderRoute: typeof AdminHelpCenterIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feedback/': {
      id: '/admin/feedback/'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags/': {
      id: '/admin/feature-flags/'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/evaluations/': {
      id: '/admin/evaluations/'
      path: '/evaluations'
      fullPath: '/admin/evaluations'
      preLoaderRoute: typeof AdminEvaluationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/emails/': {
      id: '/admin/emails/'
      path: '/emails'
      fullPath: '/admin/emails'
      preLoaderRoute: typeof AdminEmailsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/email-templates/': {
      id: '/admin/email-templates/'
      path: '/email-templates'
      fullPath: '/admin/email-templates'
      preLoaderRoute: typeof AdminEmailTemplatesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/data-rooms/': {
      id: '/admin/data-rooms/'
      path: '/data-rooms'
      fullPath: '/admin/data-rooms'
      preLoaderRoute: typeof AdminDataRoomsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/blog/': {
      id: '/admin/blog/'
      path: '/blog'
      fullPath: '/admin/blog'
      preLoaderRoute: typeof AdminBlogIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/agent/': {
      id: '/admin/agent/'
      path: '/agent'
      fullPath: '/admin/agent'
      preLoaderRoute: typeof AdminAgentIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/startup/$id': {
      id: '/app/startup/$id'
      path: '/startup/$id'
      fullPath: '/app/startup/$id'
      preLoaderRoute: typeof AppStartupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/oauth/login': {
      id: '/app/oauth/login'
      path: '/oauth/login'
      fullPath: '/app/oauth/login'
      preLoaderRoute: typeof AppOauthLoginRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/oauth/consent': {
      id: '/app/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/app/oauth/consent'
      preLoaderRoute: typeof AppOauthConsentRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/investor/$id': {
      id: '/app/investor/$id'
      path: '/investor/$id'
      fullPath: '/app/investor/$id'
      preLoaderRoute: typeof AppInvestorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/evaluate/$startupId': {
      id: '/app/evaluate/$startupId'
      path: '/evaluate/$startupId'
      fullPath: '/app/evaluate/$startupId'
      preLoaderRoute: typeof AppEvaluateStartupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/startups/$id': {
      id: '/admin/startups/$id'
      path: '/startups/$id'
      fullPath: '/admin/startups/$id'
      preLoaderRoute: typeof AdminStartupsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile-chats/$conversationId': {
      id: '/admin/profile-chats/$conversationId'
      path: '/profile-chats/$conversationId'
      fullPath: '/admin/profile-chats/$conversationId'
      preLoaderRoute: typeof AdminProfileChatsConversationIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/outreach/reply-classification': {
      id: '/admin/outreach/reply-classification'
      path: '/outreach/reply-classification'
      fullPath: '/admin/outreach/reply-classification'
      preLoaderRoute: typeof AdminOutreachReplyClassificationRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/update-proposals': {
      id: '/admin/investors/update-proposals'
      path: '/investors/update-proposals'
      fullPath: '/admin/investors/update-proposals'
      preLoaderRoute: typeof AdminInvestorsUpdateProposalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/portfolio-research': {
      id: '/admin/investors/portfolio-research'
      path: '/investors/portfolio-research'
      fullPath: '/admin/investors/portfolio-research'
      preLoaderRoute: typeof AdminInvestorsPortfolioResearchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/persona-research': {
      id: '/admin/investors/persona-research'
      path: '/investors/persona-research'
      fullPath: '/admin/investors/persona-research'
      preLoaderRoute: typeof AdminInvestorsPersonaResearchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/normalize-preferences': {
      id: '/admin/investors/normalize-preferences'
      path: '/investors/normalize-preferences'
      fullPath: '/admin/investors/normalize-preferences'
      preLoaderRoute: typeof AdminInvestorsNormalizePreferencesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/activity-research': {
      id: '/admin/investors/activity-research'
      path: '/investors/activity-research'
      fullPath: '/admin/investors/activity-research'
      preLoaderRoute: typeof AdminInvestorsActivityResearchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/$id': {
      id: '/admin/investors/$id'
      path: '/investors/$id'
      fullPath: '/admin/investors/$id'
      preLoaderRoute: typeof AdminInvestorsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-center/new': {
      id: '/admin/help-center/new'
      path: '/help-center/new'
      fullPath: '/admin/help-center/new'
      preLoaderRoute: typeof AdminHelpCenterNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-center/$id': {
      id: '/admin/help-center/$id'
      path: '/help-center/$id'
      fullPath: '/admin/help-center/$id'
      preLoaderRoute: typeof AdminHelpCenterIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/evaluations/$id': {
      id: '/admin/evaluations/$id'
      path: '/evaluations/$id'
      fullPath: '/admin/evaluations/$id'
      preLoaderRoute: typeof AdminEvaluationsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/emails/$id': {
      id: '/admin/emails/$id'
      path: '/emails/$id'
      fullPath: '/admin/emails/$id'
      preLoaderRoute: typeof AdminEmailsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/email-templates/$type': {
      id: '/admin/email-templates/$type'
      path: '/email-templates/$type'
      fullPath: '/admin/email-templates/$type'
      preLoaderRoute: typeof AdminEmailTemplatesTypeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/data-rooms/$id': {
      id: '/admin/data-rooms/$id'
      path: '/data-rooms/$id'
      fullPath: '/admin/data-rooms/$id'
      preLoaderRoute: typeof AdminDataRoomsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/blog/new': {
      id: '/admin/blog/new'
      path: '/blog/new'
      fullPath: '/admin/blog/new'
      preLoaderRoute: typeof AdminBlogNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/blog/$id': {
      id: '/admin/blog/$id'
      path: '/blog/$id'
      fullPath: '/admin/blog/$id'
      preLoaderRoute: typeof AdminBlogIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/startup/$id/': {
      id: '/app/startup/$id/'
      path: '/'
      fullPath: '/app/startup/$id/'
      preLoaderRoute: typeof AppStartupIdIndexRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/investor/$id/': {
      id: '/app/investor/$id/'
      path: '/'
      fullPath: '/app/investor/$id/'
      preLoaderRoute: typeof AppInvestorIdIndexRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/admin/agent/observers/': {
      id: '/admin/agent/observers/'
      path: '/agent/observers'
      fullPath: '/admin/agent/observers'
      preLoaderRoute: typeof AdminAgentObserversIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/startup/$id/updates': {
      id: '/app/startup/$id/updates'
      path: '/updates'
      fullPath: '/app/startup/$id/updates'
      preLoaderRoute: typeof AppStartupIdUpdatesRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/settings': {
      id: '/app/startup/$id/settings'
      path: '/settings'
      fullPath: '/app/startup/$id/settings'
      preLoaderRoute: typeof AppStartupIdSettingsRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/profile': {
      id: '/app/startup/$id/profile'
      path: '/profile'
      fullPath: '/app/startup/$id/profile'
      preLoaderRoute: typeof AppStartupIdProfileRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/preferences': {
      id: '/app/startup/$id/preferences'
      path: '/preferences'
      fullPath: '/app/startup/$id/preferences'
      preLoaderRoute: typeof AppStartupIdPreferencesRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/pitch': {
      id: '/app/startup/$id/pitch'
      path: '/pitch'
      fullPath: '/app/startup/$id/pitch'
      preLoaderRoute: typeof AppStartupIdPitchRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/outreach': {
      id: '/app/startup/$id/outreach'
      path: '/outreach'
      fullPath: '/app/startup/$id/outreach'
      preLoaderRoute: typeof AppStartupIdOutreachRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/me': {
      id: '/app/startup/$id/me'
      path: '/me'
      fullPath: '/app/startup/$id/me'
      preLoaderRoute: typeof AppStartupIdMeRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/investors': {
      id: '/app/startup/$id/investors'
      path: '/investors'
      fullPath: '/app/startup/$id/investors'
      preLoaderRoute: typeof AppStartupIdInvestorsRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/feed': {
      id: '/app/startup/$id/feed'
      path: '/feed'
      fullPath: '/app/startup/$id/feed'
      preLoaderRoute: typeof AppStartupIdFeedRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/billing': {
      id: '/app/startup/$id/billing'
      path: '/billing'
      fullPath: '/app/startup/$id/billing'
      preLoaderRoute: typeof AppStartupIdBillingRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/activity': {
      id: '/app/startup/$id/activity'
      path: '/activity'
      fullPath: '/app/startup/$id/activity'
      preLoaderRoute: typeof AppStartupIdActivityRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/investor/$id/wallet': {
      id: '/app/investor/$id/wallet'
      path: '/wallet'
      fullPath: '/app/investor/$id/wallet'
      preLoaderRoute: typeof AppInvestorIdWalletRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/settings': {
      id: '/app/investor/$id/settings'
      path: '/settings'
      fullPath: '/app/investor/$id/settings'
      preLoaderRoute: typeof AppInvestorIdSettingsRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/search': {
      id: '/app/investor/$id/search'
      path: '/search'
      fullPath: '/app/investor/$id/search'
      preLoaderRoute: typeof AppInvestorIdSearchRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/privacy': {
      id: '/app/investor/$id/privacy'
      path: '/privacy'
      fullPath: '/app/investor/$id/privacy'
      preLoaderRoute: typeof AppInvestorIdPrivacyRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/preferences': {
      id: '/app/investor/$id/preferences'
      path: '/preferences'
      fullPath: '/app/investor/$id/preferences'
      preLoaderRoute: typeof AppInvestorIdPreferencesRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/notifications': {
      id: '/app/investor/$id/notifications'
      path: '/notifications'
      fullPath: '/app/investor/$id/notifications'
      preLoaderRoute: typeof AppInvestorIdNotificationsRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/me': {
      id: '/app/investor/$id/me'
      path: '/me'
      fullPath: '/app/investor/$id/me'
      preLoaderRoute: typeof AppInvestorIdMeRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/follows': {
      id: '/app/investor/$id/follows'
      path: '/follows'
      fullPath: '/app/investor/$id/follows'
      preLoaderRoute: typeof AppInvestorIdFollowsRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/feed': {
      id: '/app/investor/$id/feed'
      path: '/feed'
      fullPath: '/app/investor/$id/feed'
      preLoaderRoute: typeof AppInvestorIdFeedRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/deal-flow': {
      id: '/app/investor/$id/deal-flow'
      path: '/deal-flow'
      fullPath: '/app/investor/$id/deal-flow'
      preLoaderRoute: typeof AppInvestorIdDealFlowRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/credits': {
      id: '/app/investor/$id/credits'
      path: '/credits'
      fullPath: '/app/investor/$id/credits'
      preLoaderRoute: typeof AppInvestorIdCreditsRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/connect-ai': {
      id: '/app/investor/$id/connect-ai'
      path: '/connect-ai'
      fullPath: '/app/investor/$id/connect-ai'
      preLoaderRoute: typeof AppInvestorIdConnectAiRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/startup/$id/profile/': {
      id: '/app/startup/$id/profile/'
      path: '/'
      fullPath: '/app/startup/$id/profile/'
      preLoaderRoute: typeof AppStartupIdProfileIndexRouteImport
      parentRoute: typeof AppStartupIdProfileRoute
    }
    '/app/startup/$id/outreach/': {
      id: '/app/startup/$id/outreach/'
      path: '/'
      fullPath: '/app/startup/$id/outreach/'
      preLoaderRoute: typeof AppStartupIdOutreachIndexRouteImport
      parentRoute: typeof AppStartupIdOutreachRoute
    }
    '/app/startup/$id/settings/billing': {
      id: '/app/startup/$id/settings/billing'
      path: '/billing'
      fullPath: '/app/startup/$id/settings/billing'
      preLoaderRoute: typeof AppStartupIdSettingsBillingRouteImport
      parentRoute: typeof AppStartupIdSettingsRoute
    }
    '/app/startup/$id/settings/analytics': {
      id: '/app/startup/$id/settings/analytics'
      path: '/analytics'
      fullPath: '/app/startup/$id/settings/analytics'
      preLoaderRoute: typeof AppStartupIdSettingsAnalyticsRouteImport
      parentRoute: typeof AppStartupIdSettingsRoute
    }
    '/app/startup/$id/profile/links': {
      id: '/app/startup/$id/profile/links'
      path: '/links'
      fullPath: '/app/startup/$id/profile/links'
      preLoaderRoute: typeof AppStartupIdProfileLinksRouteImport
      parentRoute: typeof AppStartupIdProfileRoute
    }
    '/app/startup/$id/profile/deep-insights': {
      id: '/app/startup/$id/profile/deep-insights'
      path: '/deep-insights'
      fullPath: '/app/startup/$id/profile/deep-insights'
      preLoaderRoute: typeof AppStartupIdProfileDeepInsightsRouteImport
      parentRoute: typeof AppStartupIdProfileRoute
    }
    '/app/startup/$id/profile/analytics': {
      id: '/app/startup/$id/profile/analytics'
      path: '/analytics'
      fullPath: '/app/startup/$id/profile/analytics'
      preLoaderRoute: typeof AppStartupIdProfileAnalyticsRouteImport
      parentRoute: typeof AppStartupIdProfileRoute
    }
    '/app/startup/$id/pitch_/start': {
      id: '/app/startup/$id/pitch_/start'
      path: '/pitch/start'
      fullPath: '/app/startup/$id/pitch/start'
      preLoaderRoute: typeof AppStartupIdPitchStartRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/startup/$id/outreach/replies': {
      id: '/app/startup/$id/outreach/replies'
      path: '/replies'
      fullPath: '/app/startup/$id/outreach/replies'
      preLoaderRoute: typeof AppStartupIdOutreachRepliesRouteImport
      parentRoute: typeof AppStartupIdOutreachRoute
    }
    '/app/startup/$id/outreach/archive': {
      id: '/app/startup/$id/outreach/archive'
      path: '/archive'
      fullPath: '/app/startup/$id/outreach/archive'
      preLoaderRoute: typeof AppStartupIdOutreachArchiveRouteImport
      parentRoute: typeof AppStartupIdOutreachRoute
    }
    '/app/startup/$id/evaluation/$evaluationId': {
      id: '/app/startup/$id/evaluation/$evaluationId'
      path: '/evaluation/$evaluationId'
      fullPath: '/app/startup/$id/evaluation/$evaluationId'
      preLoaderRoute: typeof AppStartupIdEvaluationEvaluationIdRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/investor/$id/startup/$token': {
      id: '/app/investor/$id/startup/$token'
      path: '/startup/$token'
      fullPath: '/app/investor/$id/startup/$token'
      preLoaderRoute: typeof AppInvestorIdStartupTokenRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/evaluation/$evaluationId': {
      id: '/app/investor/$id/evaluation/$evaluationId'
      path: '/evaluation/$evaluationId'
      fullPath: '/app/investor/$id/evaluation/$evaluationId'
      preLoaderRoute: typeof AppInvestorIdEvaluationEvaluationIdRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/evaluate/$startupId': {
      id: '/app/investor/$id/evaluate/$startupId'
      path: '/evaluate/$startupId'
      fullPath: '/app/investor/$id/evaluate/$startupId'
      preLoaderRoute: typeof AppInvestorIdEvaluateStartupIdRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/deal-flow_/archive': {
      id: '/app/investor/$id/deal-flow_/archive'
      path: '/deal-flow/archive'
      fullPath: '/app/investor/$id/deal-flow/archive'
      preLoaderRoute: typeof AppInvestorIdDealFlowArchiveRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/app/investor/$id/deal-flow_/$startupId': {
      id: '/app/investor/$id/deal-flow_/$startupId'
      path: '/deal-flow/$startupId'
      fullPath: '/app/investor/$id/deal-flow/$startupId'
      preLoaderRoute: typeof AppInvestorIdDealFlowStartupIdRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
    '/admin/evaluations/$id/judge/$judgeKey': {
      id: '/admin/evaluations/$id/judge/$judgeKey'
      path: '/judge/$judgeKey'
      fullPath: '/admin/evaluations/$id/judge/$judgeKey'
      preLoaderRoute: typeof AdminEvaluationsIdJudgeJudgeKeyRouteImport
      parentRoute: typeof AdminEvaluationsIdRoute
    }
    '/app/startup/$id/judge/$judgeKey/$evaluationId': {
      id: '/app/startup/$id/judge/$judgeKey/$evaluationId'
      path: '/judge/$judgeKey/$evaluationId'
      fullPath: '/app/startup/$id/judge/$judgeKey/$evaluationId'
      preLoaderRoute: typeof AppStartupIdJudgeJudgeKeyEvaluationIdRouteImport
      parentRoute: typeof AppStartupIdRoute
    }
    '/app/investor/$id/judge/$judgeKey/$evaluationId': {
      id: '/app/investor/$id/judge/$judgeKey/$evaluationId'
      path: '/judge/$judgeKey/$evaluationId'
      fullPath: '/app/investor/$id/judge/$judgeKey/$evaluationId'
      preLoaderRoute: typeof AppInvestorIdJudgeJudgeKeyEvaluationIdRouteImport
      parentRoute: typeof AppInvestorIdRoute
    }
  }
}

interface AdminEvaluationsIdRouteChildren {
  AdminEvaluationsIdJudgeJudgeKeyRoute: typeof AdminEvaluationsIdJudgeJudgeKeyRoute
}

const AdminEvaluationsIdRouteChildren: AdminEvaluationsIdRouteChildren = {
  AdminEvaluationsIdJudgeJudgeKeyRoute: AdminEvaluationsIdJudgeJudgeKeyRoute,
}

const AdminEvaluationsIdRouteWithChildren =
  AdminEvaluationsIdRoute._addFileChildren(AdminEvaluationsIdRouteChildren)

interface AdminRouteChildren {
  AdminMatcherJobsRoute: typeof AdminMatcherJobsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminBlogIdRoute: typeof AdminBlogIdRoute
  AdminBlogNewRoute: typeof AdminBlogNewRoute
  AdminDataRoomsIdRoute: typeof AdminDataRoomsIdRoute
  AdminEmailTemplatesTypeRoute: typeof AdminEmailTemplatesTypeRoute
  AdminEmailsIdRoute: typeof AdminEmailsIdRoute
  AdminEvaluationsIdRoute: typeof AdminEvaluationsIdRouteWithChildren
  AdminHelpCenterIdRoute: typeof AdminHelpCenterIdRoute
  AdminHelpCenterNewRoute: typeof AdminHelpCenterNewRoute
  AdminInvestorsIdRoute: typeof AdminInvestorsIdRoute
  AdminInvestorsActivityResearchRoute: typeof AdminInvestorsActivityResearchRoute
  AdminInvestorsNormalizePreferencesRoute: typeof AdminInvestorsNormalizePreferencesRoute
  AdminInvestorsPersonaResearchRoute: typeof AdminInvestorsPersonaResearchRoute
  AdminInvestorsPortfolioResearchRoute: typeof AdminInvestorsPortfolioResearchRoute
  AdminInvestorsUpdateProposalsRoute: typeof AdminInvestorsUpdateProposalsRoute
  AdminOutreachReplyClassificationRoute: typeof AdminOutreachReplyClassificationRoute
  AdminProfileChatsConversationIdRoute: typeof AdminProfileChatsConversationIdRoute
  AdminStartupsIdRoute: typeof AdminStartupsIdRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  AdminAgentIndexRoute: typeof AdminAgentIndexRoute
  AdminBlogIndexRoute: typeof AdminBlogIndexRoute
  AdminDataRoomsIndexRoute: typeof AdminDataRoomsIndexRoute
  AdminEmailTemplatesIndexRoute: typeof AdminEmailTemplatesIndexRoute
  AdminEmailsIndexRoute: typeof AdminEmailsIndexRoute
  AdminEvaluationsIndexRoute: typeof AdminEvaluationsIndexRoute
  AdminFeatureFlagsIndexRoute: typeof AdminFeatureFlagsIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AdminHelpCenterIndexRoute: typeof AdminHelpCenterIndexRoute
  AdminInvestorChecksIndexRoute: typeof AdminInvestorChecksIndexRoute
  AdminInvestorIndexIndexRoute: typeof AdminInvestorIndexIndexRoute
  AdminInvestorsIndexRoute: typeof AdminInvestorsIndexRoute
  AdminOutreachIndexRoute: typeof AdminOutreachIndexRoute
  AdminProfileChatsIndexRoute: typeof AdminProfileChatsIndexRoute
  AdminSignupQuestionIndexRoute: typeof AdminSignupQuestionIndexRoute
  AdminStartupsIndexRoute: typeof AdminStartupsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminAgentObserversIndexRoute: typeof AdminAgentObserversIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminMatcherJobsRoute: AdminMatcherJobsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminBlogIdRoute: AdminBlogIdRoute,
  AdminBlogNewRoute: AdminBlogNewRoute,
  AdminDataRoomsIdRoute: AdminDataRoomsIdRoute,
  AdminEmailTemplatesTypeRoute: AdminEmailTemplatesTypeRoute,
  AdminEmailsIdRoute: AdminEmailsIdRoute,
  AdminEvaluationsIdRoute: AdminEvaluationsIdRouteWithChildren,
  AdminHelpCenterIdRoute: AdminHelpCenterIdRoute,
  AdminHelpCenterNewRoute: AdminHelpCenterNewRoute,
  AdminInvestorsIdRoute: AdminInvestorsIdRoute,
  AdminInvestorsActivityResearchRoute: AdminInvestorsActivityResearchRoute,
  AdminInvestorsNormalizePreferencesRoute:
    AdminInvestorsNormalizePreferencesRoute,
  AdminInvestorsPersonaResearchRoute: AdminInvestorsPersonaResearchRoute,
  AdminInvestorsPortfolioResearchRoute: AdminInvestorsPortfolioResearchRoute,
  AdminInvestorsUpdateProposalsRoute: AdminInvestorsUpdateProposalsRoute,
  AdminOutreachReplyClassificationRoute: AdminOutreachReplyClassificationRoute,
  AdminProfileChatsConversationIdRoute: AdminProfileChatsConversationIdRoute,
  AdminStartupsIdRoute: AdminStartupsIdRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  AdminAgentIndexRoute: AdminAgentIndexRoute,
  AdminBlogIndexRoute: AdminBlogIndexRoute,
  AdminDataRoomsIndexRoute: AdminDataRoomsIndexRoute,
  AdminEmailTemplatesIndexRoute: AdminEmailTemplatesIndexRoute,
  AdminEmailsIndexRoute: AdminEmailsIndexRoute,
  AdminEvaluationsIndexRoute: AdminEvaluationsIndexRoute,
  AdminFeatureFlagsIndexRoute: AdminFeatureFlagsIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AdminHelpCenterIndexRoute: AdminHelpCenterIndexRoute,
  AdminInvestorChecksIndexRoute: AdminInvestorChecksIndexRoute,
  AdminInvestorIndexIndexRoute: AdminInvestorIndexIndexRoute,
  AdminInvestorsIndexRoute: AdminInvestorsIndexRoute,
  AdminOutreachIndexRoute: AdminOutreachIndexRoute,
  AdminProfileChatsIndexRoute: AdminProfileChatsIndexRoute,
  AdminSignupQuestionIndexRoute: AdminSignupQuestionIndexRoute,
  AdminStartupsIndexRoute: AdminStartupsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminAgentObserversIndexRoute: AdminAgentObserversIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppInvestorIdRouteChildren {
  AppInvestorIdConnectAiRoute: typeof AppInvestorIdConnectAiRoute
  AppInvestorIdCreditsRoute: typeof AppInvestorIdCreditsRoute
  AppInvestorIdDealFlowRoute: typeof AppInvestorIdDealFlowRoute
  AppInvestorIdFeedRoute: typeof AppInvestorIdFeedRoute
  AppInvestorIdFollowsRoute: typeof AppInvestorIdFollowsRoute
  AppInvestorIdMeRoute: typeof AppInvestorIdMeRoute
  AppInvestorIdNotificationsRoute: typeof AppInvestorIdNotificationsRoute
  AppInvestorIdPreferencesRoute: typeof AppInvestorIdPreferencesRoute
  AppInvestorIdPrivacyRoute: typeof AppInvestorIdPrivacyRoute
  AppInvestorIdSearchRoute: typeof AppInvestorIdSearchRoute
  AppInvestorIdSettingsRoute: typeof AppInvestorIdSettingsRoute
  AppInvestorIdWalletRoute: typeof AppInvestorIdWalletRoute
  AppInvestorIdIndexRoute: typeof AppInvestorIdIndexRoute
  AppInvestorIdDealFlowStartupIdRoute: typeof AppInvestorIdDealFlowStartupIdRoute
  AppInvestorIdDealFlowArchiveRoute: typeof AppInvestorIdDealFlowArchiveRoute
  AppInvestorIdEvaluateStartupIdRoute: typeof AppInvestorIdEvaluateStartupIdRoute
  AppInvestorIdEvaluationEvaluationIdRoute: typeof AppInvestorIdEvaluationEvaluationIdRoute
  AppInvestorIdStartupTokenRoute: typeof AppInvestorIdStartupTokenRoute
  AppInvestorIdJudgeJudgeKeyEvaluationIdRoute: typeof AppInvestorIdJudgeJudgeKeyEvaluationIdRoute
}

const AppInvestorIdRouteChildren: AppInvestorIdRouteChildren = {
  AppInvestorIdConnectAiRoute: AppInvestorIdConnectAiRoute,
  AppInvestorIdCreditsRoute: AppInvestorIdCreditsRoute,
  AppInvestorIdDealFlowRoute: AppInvestorIdDealFlowRoute,
  AppInvestorIdFeedRoute: AppInvestorIdFeedRoute,
  AppInvestorIdFollowsRoute: AppInvestorIdFollowsRoute,
  AppInvestorIdMeRoute: AppInvestorIdMeRoute,
  AppInvestorIdNotificationsRoute: AppInvestorIdNotificationsRoute,
  AppInvestorIdPreferencesRoute: AppInvestorIdPreferencesRoute,
  AppInvestorIdPrivacyRoute: AppInvestorIdPrivacyRoute,
  AppInvestorIdSearchRoute: AppInvestorIdSearchRoute,
  AppInvestorIdSettingsRoute: AppInvestorIdSettingsRoute,
  AppInvestorIdWalletRoute: AppInvestorIdWalletRoute,
  AppInvestorIdIndexRoute: AppInvestorIdIndexRoute,
  AppInvestorIdDealFlowStartupIdRoute: AppInvestorIdDealFlowStartupIdRoute,
  AppInvestorIdDealFlowArchiveRoute: AppInvestorIdDealFlowArchiveRoute,
  AppInvestorIdEvaluateStartupIdRoute: AppInvestorIdEvaluateStartupIdRoute,
  AppInvestorIdEvaluationEvaluationIdRoute:
    AppInvestorIdEvaluationEvaluationIdRoute,
  AppInvestorIdStartupTokenRoute: AppInvestorIdStartupTokenRoute,
  AppInvestorIdJudgeJudgeKeyEvaluationIdRoute:
    AppInvestorIdJudgeJudgeKeyEvaluationIdRoute,
}

const AppInvestorIdRouteWithChildren = AppInvestorIdRoute._addFileChildren(
  AppInvestorIdRouteChildren,
)

interface AppStartupIdOutreachRouteChildren {
  AppStartupIdOutreachArchiveRoute: typeof AppStartupIdOutreachArchiveRoute
  AppStartupIdOutreachRepliesRoute: typeof AppStartupIdOutreachRepliesRoute
  AppStartupIdOutreachIndexRoute: typeof AppStartupIdOutreachIndexRoute
}

const AppStartupIdOutreachRouteChildren: AppStartupIdOutreachRouteChildren = {
  AppStartupIdOutreachArchiveRoute: AppStartupIdOutreachArchiveRoute,
  AppStartupIdOutreachRepliesRoute: AppStartupIdOutreachRepliesRoute,
  AppStartupIdOutreachIndexRoute: AppStartupIdOutreachIndexRoute,
}

const AppStartupIdOutreachRouteWithChildren =
  AppStartupIdOutreachRoute._addFileChildren(AppStartupIdOutreachRouteChildren)

interface AppStartupIdProfileRouteChildren {
  AppStartupIdProfileAnalyticsRoute: typeof AppStartupIdProfileAnalyticsRoute
  AppStartupIdProfileDeepInsightsRoute: typeof AppStartupIdProfileDeepInsightsRoute
  AppStartupIdProfileLinksRoute: typeof AppStartupIdProfileLinksRoute
  AppStartupIdProfileIndexRoute: typeof AppStartupIdProfileIndexRoute
}

const AppStartupIdProfileRouteChildren: AppStartupIdProfileRouteChildren = {
  AppStartupIdProfileAnalyticsRoute: AppStartupIdProfileAnalyticsRoute,
  AppStartupIdProfileDeepInsightsRoute: AppStartupIdProfileDeepInsightsRoute,
  AppStartupIdProfileLinksRoute: AppStartupIdProfileLinksRoute,
  AppStartupIdProfileIndexRoute: AppStartupIdProfileIndexRoute,
}

const AppStartupIdProfileRouteWithChildren =
  AppStartupIdProfileRoute._addFileChildren(AppStartupIdProfileRouteChildren)

interface AppStartupIdSettingsRouteChildren {
  AppStartupIdSettingsAnalyticsRoute: typeof AppStartupIdSettingsAnalyticsRoute
  AppStartupIdSettingsBillingRoute: typeof AppStartupIdSettingsBillingRoute
}

const AppStartupIdSettingsRouteChildren: AppStartupIdSettingsRouteChildren = {
  AppStartupIdSettingsAnalyticsRoute: AppStartupIdSettingsAnalyticsRoute,
  AppStartupIdSettingsBillingRoute: AppStartupIdSettingsBillingRoute,
}

const AppStartupIdSettingsRouteWithChildren =
  AppStartupIdSettingsRoute._addFileChildren(AppStartupIdSettingsRouteChildren)

interface AppStartupIdRouteChildren {
  AppStartupIdActivityRoute: typeof AppStartupIdActivityRoute
  AppStartupIdBillingRoute: typeof AppStartupIdBillingRoute
  AppStartupIdFeedRoute: typeof AppStartupIdFeedRoute
  AppStartupIdInvestorsRoute: typeof AppStartupIdInvestorsRoute
  AppStartupIdMeRoute: typeof AppStartupIdMeRoute
  AppStartupIdOutreachRoute: typeof AppStartupIdOutreachRouteWithChildren
  AppStartupIdPitchRoute: typeof AppStartupIdPitchRoute
  AppStartupIdPreferencesRoute: typeof AppStartupIdPreferencesRoute
  AppStartupIdProfileRoute: typeof AppStartupIdProfileRouteWithChildren
  AppStartupIdSettingsRoute: typeof AppStartupIdSettingsRouteWithChildren
  AppStartupIdUpdatesRoute: typeof AppStartupIdUpdatesRoute
  AppStartupIdIndexRoute: typeof AppStartupIdIndexRoute
  AppStartupIdEvaluationEvaluationIdRoute: typeof AppStartupIdEvaluationEvaluationIdRoute
  AppStartupIdPitchStartRoute: typeof AppStartupIdPitchStartRoute
  AppStartupIdJudgeJudgeKeyEvaluationIdRoute: typeof AppStartupIdJudgeJudgeKeyEvaluationIdRoute
}

const AppStartupIdRouteChildren: AppStartupIdRouteChildren = {
  AppStartupIdActivityRoute: AppStartupIdActivityRoute,
  AppStartupIdBillingRoute: AppStartupIdBillingRoute,
  AppStartupIdFeedRoute: AppStartupIdFeedRoute,
  AppStartupIdInvestorsRoute: AppStartupIdInvestorsRoute,
  AppStartupIdMeRoute: AppStartupIdMeRoute,
  AppStartupIdOutreachRoute: AppStartupIdOutreachRouteWithChildren,
  AppStartupIdPitchRoute: AppStartupIdPitchRoute,
  AppStartupIdPreferencesRoute: AppStartupIdPreferencesRoute,
  AppStartupIdProfileRoute: AppStartupIdProfileRouteWithChildren,
  AppStartupIdSettingsRoute: AppStartupIdSettingsRouteWithChildren,
  AppStartupIdUpdatesRoute: AppStartupIdUpdatesRoute,
  AppStartupIdIndexRoute: AppStartupIdIndexRoute,
  AppStartupIdEvaluationEvaluationIdRoute:
    AppStartupIdEvaluationEvaluationIdRoute,
  AppStartupIdPitchStartRoute: AppStartupIdPitchStartRoute,
  AppStartupIdJudgeJudgeKeyEvaluationIdRoute:
    AppStartupIdJudgeJudgeKeyEvaluationIdRoute,
}

const AppStartupIdRouteWithChildren = AppStartupIdRoute._addFileChildren(
  AppStartupIdRouteChildren,
)

interface AppRouteChildren {
  AppConnectAiRoute: typeof AppConnectAiRoute
  AppIndexRoute: typeof AppIndexRoute
  AppEvaluateStartupIdRoute: typeof AppEvaluateStartupIdRoute
  AppInvestorIdRoute: typeof AppInvestorIdRouteWithChildren
  AppOauthConsentRoute: typeof AppOauthConsentRoute
  AppOauthLoginRoute: typeof AppOauthLoginRoute
  AppStartupIdRoute: typeof AppStartupIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppConnectAiRoute: AppConnectAiRoute,
  AppIndexRoute: AppIndexRoute,
  AppEvaluateStartupIdRoute: AppEvaluateStartupIdRoute,
  AppInvestorIdRoute: AppInvestorIdRouteWithChildren,
  AppOauthConsentRoute: AppOauthConsentRoute,
  AppOauthLoginRoute: AppOauthLoginRoute,
  AppStartupIdRoute: AppStartupIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LivekitEgressTemplateRoute: LivekitEgressTemplateRoute,
  DevHeyreachRoute: DevHeyreachRoute,
  ITokenRoute: ITokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
